"use client";
import React from "react";

import {
  TextElementNova,
  type TextElementNovaProps,
} from "@/components/ui-kit/TextElementNova/TextElementNova";

type TextElementMenProps = TextElementNovaProps;

export const TextElementMen: React.FC<TextElementMenProps> = ({
  text,
  element = "p",
  onClick,
  onKeyPress,
  className = "",
  styles,
  sanitize = false,
  classes = {},
  children,
}) => {
  if (children) {
    return (
      <TextElementNova
        className={`men ${className}`}
        element={element}
        styles={styles}
        sanitize={sanitize}
        onClick={onClick}
        onKeyPress={onKeyPress}
        classes={classes}
      >
        {children}
      </TextElementNova>
    );
  }
  return (
    <TextElementNova
      className={`men ${className}`}
      text={text}
      element={element}
      styles={styles}
      sanitize={sanitize}
      classes={classes}
      onClick={onClick}
      onKeyPress={onKeyPress}
    />
  );
};
